module.exports = __webpack_public_path__ + "static/media/interpol-red-notice.a80faf72.png";